import axios from 'axios';
const backendUrl = (process.env.REACT_APP_BACKEND_URL || 'https://healthbuddy-backend-neg6.onrender.com').replace(/\/+$/, '');
export const API = `${backendUrl}/api`;
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'ngrok-skip-browser-warning': 'true',
  },
});
api.interceptors.request.use((c) => {
  const t = localStorage.getItem('hb_token');
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

let isRefreshing = false;
let waiters = [];
const flushWaiters = (token) => {
  waiters.forEach((cb) => cb(token));
  waiters = [];
};

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const url = original?.url || '';
    const isAuthFlow = url.includes('/auth/otp/') || url.includes('/auth/google') || url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/refresh');
    if (!original || status !== 401 || original._retry || isAuthFlow) {
      return Promise.reject(error);
    }
    const refresh = localStorage.getItem('hb_refresh_token');
    if (!refresh) return Promise.reject(error);

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        waiters.push((newToken) => {
          if (!newToken) return reject(error);
          original.headers = original.headers || {};
          original.headers.Authorization = `Bearer ${newToken}`;
          resolve(api(original));
        });
      });
    }

    original._retry = true;
    isRefreshing = true;
    try {
      const { data } = await axios.post(
        `${API}/auth/refresh`,
        { refresh_token: refresh },
        { headers: { 'ngrok-skip-browser-warning': 'true' } }
      );
      localStorage.setItem('hb_token', data.token);
      if (data.refresh_token) localStorage.setItem('hb_refresh_token', data.refresh_token);
      flushWaiters(data.token);
      original.headers = original.headers || {};
      original.headers.Authorization = `Bearer ${data.token}`;
      return api(original);
    } catch (e) {
      localStorage.removeItem('hb_token');
      localStorage.removeItem('hb_refresh_token');
      localStorage.removeItem('hb_user');
      localStorage.removeItem('hb_doctor');
      flushWaiters(null);
      return Promise.reject(e);
    } finally {
      isRefreshing = false;
    }
  }
);
